import React from 'react';
import ProjectPageLayout from '../../components/ProjectPageLayout';
import SEO from '../../components/SEO';

const RehabilitationCentreMountAbu = () => {
  const history = (
    <>
      <h4>ORIGIN</h4>
      <p>The NAB–Phiroze & Noshir Merwanji Rehabilitation Centre for the Blind, Mount Abu is a full-fledged Basic Rehabilitation Training Centre for the newly adult blind in India, established on 1st August, 1967. Its aims are adjusting and orienting the newly blind and those who have had no institutional training.</p>
      <p>The Centre aims to adjust and orient those born blind and the newly-blind in day-to-day living and train them in crafts for future livelihood. Subsequently, it has started a middle school for the blind recognised by the Rajasthan Board. The Centre is an activity of the National Association for the Blind (India), Mumbai and registered under the Societies Registration Act 1958 and the Public Trust Act 1959. It is also registered under section 52 of PWD Act 1995.</p>
    </>
  );

  const activities = (
    <>
      <h4>Activities</h4>
      <p>The basic aim of the Centre is to restore the blind client to the fullest normalcy permitted by his handicap. Thus our aim is to educate and rehabilitate the blind to live and do all that can be done as a sighted person. By doing this we hope to help them get their confidence back.</p>
      
      <h4>Eligibility of admission:</h4>
      <p><strong>No. 1. Admission is given in the training centre to:</strong></p>
      <ul>
        <li>(a)  Fully or partially blind of both sexes, aged 16 to 40 years.</li>
        <li>(b) Those who have not received any such training in any other institutions for the blind.</li>
        <li>Blind at birth or recently blind (fully or partially).</li>
      </ul>
      <p><strong>No. 2. Admission in the school section is given to:</strong></p>
      <ul>
        <li>(a) Blind of both sexes aged 5 to 16 years.</li>
        <li>(b) Those blind who are illiterate or have had some education at the primary level.</li>
        <li>(c) Blind at birth or recently blind (fully or partially).</li>
      </ul>

      <h4>Facilities to the trainees:</h4>
      <p>Prescribed application forms for admission and other relevant information are available from the office of the above centre FREE OF COST. It is a residential rehabilitation training centre-cum-school providing lodging, boarding, training, education, casual medical treatments and clothing to the blind students all FREE OF COST. Rs. 60/- per month is given as pocket money. There is No fee whatsoever being charged.</p>

      <h4>Rehabilitation-education programme:</h4>
      <p>This Centre is recognised by central and state governments for the purpose of rehabilitation-education. The educative programme at the Centre envisages education in adjustment and rehabilitation. Modern methodology and aids are being adopted by our staff to educate our clients so that they can develop self reliance and confidence with a view to living a normal life as self respecting citizens.</p>
      <p>On an average clients pass out after about one year of general training. However, cases requiring longer training are allowed to do so.</p>
      <p>During the year under report all the following sections worked satisfactorily in a well organised way –</p>
      <ul>
        <li>Computer training.</li>
        <li>Home economics and daily living skills</li>
        <li>Dhaba Management Training</li>
        <li>Braille and communication skills</li>
        <li>Pre-vocational and crafts (handicrafts) such as – Chair Recaning, Doormat Making.</li>
        <li>Gardening activities</li>
        <li>Physical training including games and sports</li>
        <li>Music Training(Vocal & instrumental)</li>
        <li>Candle making training</li>
        <li>Chalk making training</li>
        <li>Phenyl making training.</li>
        <li>Liquid soap making training.</li>
        <li>Practical training through Work Centre for the Blind</li>
      </ul>

      <h4>Education:</h4>
      <p>From the year 2002-2003 we have started Upper primary level special school for the blind from class 1st to class 8th. This is recognised by the Rajasthan Board. We give education to blind children through Braille books and the audio books.</p>
    </>
  );

  const committeeMembers = (
    <>
      <h4>LIST OF MEMBERS OF THE MANAGING COMMITTEE OF NAB – P. & N. M. REHABILITATION CENTRE FOR THE BLIND, DELWARA ROAD, MOUNT ABU – 307 501 (RAJ.)</h4>
      <ul>
        <li><strong>Shri Bhasker Y. Mehata S/o Late Shri Yogendra Mehata:</strong> Chairman</li>
        <li><strong>Mr. K. N. Contractor S/o Lt.Shri Nariman Contractor:</strong> Co-Chairman</li>
        <li><strong>Dr. A. K. Sharma S/o Late Shri D. D. Sharma:</strong> Hon. Secretary</li>
        <li><strong>Mr. Bhupendra Singh Jain S/o Shri Gopal Singh Jain:</strong> Hon. Joint Secretary</li>
        <li><strong>Mrs. Roshan Sheikh W/o Shri Safik Saikh:</strong> Hon. Treasurer</li>
        <li><strong>Mr. Lalit Vaishnav S/o Shri Mohan Das Vaishnav:</strong> Hon. Treasurer</li>
        <li><strong>Mr. Virendra Surana S/o Lt. Shri Mukan Mal Surana:</strong> Member</li>
        <li><strong>Mr. Lalit Vora S/o Shri Dayashankar Vora:</strong> Member</li>
        <li><strong>Dr.Vimal Kumar Dengla S/o Shri Mahesh Chandra Dengla:</strong> Member Secretary</li>
        <li><strong>Mr. Anand S. Athalekar (Representative from NAB(India), Mumbai.):</strong> Hon. Secretary General  NAB, India</li>
        <li><strong>Anil Mittal (Secretary NAB, India) (Rep. from NAB,India, Mumbai.):</strong> Member</li>
        <li><strong>Pallavi Kadam(Exec. Director NAB, India (Rep. from NAB,India, Mumbai.):</strong> Member</li>
        <li><strong>Mr. Jehangir Merwanji S/o Shri Phiroze Merwanji (Rep. of Donor family):</strong> Member</li>
        <li><strong>Mrs. Vera j. Merwanji W/o  Mr. Jehangir Merwanji (Rep. of Donor family):</strong> Member</li>
        <li><strong>Mr. Laxman Rana (Rep. of Parents of Student):</strong> Member</li>
        <li><strong>Vipul Garg (Rep. of  Ex. Student):</strong> Member</li>
        <li><strong>The District Education Officer, Sirohi (Rep. from Elementary Education Dept of Rajasthan):</strong> Member Ex-Officio</li>
        <li><strong>The Assistant director, S.J.& E, Sirohi (Rep. from SJ&E Dept. of Rajasthan):</strong> Member Ex-Officio</li>
      </ul>
    </>
  );

  const contactInfo = (
    <>
      <p>For more Details Visit : <a href="http://www.nabmountabu.org" target="_blank" rel="noopener noreferrer">www.nabmountabu.org</a></p>
      <p>Email: nabmountabu@gmail.com</p>
      <p>NAB-P&NM Rehabilitation Centre for the Blind</p>
      <p>“East View” Delwara Road, Mount Abu</p>
      <p>Dist. Sirohi, Rajasthan – 307501</p>
    </>
  );

  return (
    <>
      <SEO
        title="NAB Rehabilitation Centre, Mount Abu - Training for the Blind"
        description="The NAB Phiroze & Noshir Merwanji Rehabilitation Centre in Mount Abu offers comprehensive rehabilitation and education for newly blind adults and children, empowering them for independent living."
        keywords="NAB Mount Abu, rehabilitation centre for blind, training for newly blind, special school for blind Rajasthan, vocational training Mount Abu"
      />
      <ProjectPageLayout
        title="Rehabilitation Centre Mount Abu"
        imageUrl="/images/Projects/rehab-center-mount-abu.jpg"
        history={history}
        aimsAndObjectives={activities}
        additionalContent={committeeMembers}
        contactInfo={contactInfo}
      />
    </>
  );
};

export default RehabilitationCentreMountAbu;
